import { useState, useEffect } from 'react'
import { useMap } from '@vis.gl/react-google-maps'

export const useMapViewState = () => {
  const map = useMap()
  const [viewState, setViewState] = useState({
    zoom: 4,
    bounds: [-180, -85, 180, 85],
  })

  useEffect(() => {
    if (!map) return

    const updateView = () => {
      const b = map.getBounds()
      if (b) {
        const zoom = map.getZoom()
        const sw = b.getSouthWest()
        const ne = b.getNorthEast()
        const wLng = sw.lng()
        const sLat = sw.lat()
        const eLng = ne.lng()
        const nLat = ne.lat()
        // Use functional update and bail out when values are unchanged.
        // Critical for vector mode: deck.gl calls map.requestRender() which fires
        // idle events even when the viewport hasn't moved.  Without this guard,
        // a new bounds array reference on every call creates an infinite re-render loop.
        setViewState(prev => {
          if (
            prev.zoom === zoom &&
            prev.bounds[0] === wLng &&
            prev.bounds[1] === sLat &&
            prev.bounds[2] === eLng &&
            prev.bounds[3] === nLat
          ) {
            return prev
          }
          return { zoom, bounds: [wLng, sLat, eLng, nLat] }
        })
      }
    }

    // Initial set — may return null bounds if the map projection isn't ready yet
    updateView()

    // `tilesloaded` fires as soon as the initial tiles are rendered and
    // getBounds() becomes reliable — earlier than `idle` in vector/WebGL mode.
    // `idle` covers subsequent pan/zoom interactions.
    const tilesListener = map.addListener('tilesloaded', updateView)
    const idleListener = map.addListener('idle', updateView)

    return () => {
      if (google && google.maps) {
        google.maps.event.removeListener(tilesListener)
        google.maps.event.removeListener(idleListener)
      }
    }
  }, [map])

  return viewState
}
